import axios, { AxiosInstance } from 'axios';
import { Http } from '@app/base';
import { useActivity, useActivityKinds, useActivityList } from '@webinex/activity';

const axiosInstance: AxiosInstance = axios.create({ baseURL: '/api/activity' });

axiosInstance.interceptors.request.use(async (request) => {
  const { key, value } = await Http.getAuthHeader();
  request.headers![key] = value;
  return request;
});

export enum DataChangeType {
  Added = 5,
  Deleted = 10,
  Updated = 15,
}

export interface DataChangeValue {
  Type: DataChangeType;
  Name: string;
  PrimaryKey: Record<string, any>;
  Values?: Record<string, any>;
  OriginalValues?: Record<string, any>;
}

export function useAppActivityList() {
  return useActivityList({ axios: axiosInstance });
}

export function useAppActivity(id: string) {
  return useActivity(id, { axios: axiosInstance });
}

export function useAppActivityKinds() {
  return useActivityKinds({ axios: axiosInstance });
}
